module.exports = __webpack_public_path__ + "static/media/AdelonBold.f75e1802.ttf";